<template>
<div class="two-col-wrapper"> 

    <template v-for="(section, s_index) in sections" >
        <component 
            :key="`${section.id}-section`" 
            v-if="s_index < 2" 
            :is="getSectionComponent(section)" 
            :section="section" 
            :issue="issue"
            />
    </template>

</div><!--End of two col-wrapper-->
</template>

<script>



import PaCommonMixin from './PaCommonMixin.js';

export default {
    name: 'top-sections',
    props: {
        sections: {
            type: Array,
            require: true,
        },
        issue: {
            type: Object,
            required: true,
        },
    },
    mixins: [
        PaCommonMixin,
    ],
}
</script>